import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString } from "utils/Constant";
import { ApiDeleteUserLocationAccess, ApiGetUserLocationByUserId, ApiGetUserLocationList, ApiInsertUserLocationAccess } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import Dropdown from "components/Input/Dropdown";

export default function LocationAccessModal({ isOpen, onClose, userId, name }){
    let navigate = useNavigate()

    const { fetch: apiGetLocationList } = useFetch(ApiGetUserLocationList)
    const { fetch: apiInsertUserLocationAccess } = useFetch(ApiInsertUserLocationAccess)
    const { fetch: apiGetUserLocationByUserId } = useFetch(ApiGetUserLocationByUserId)
    const { fetch: apiDeleteUserLocation } = useFetch(ApiDeleteUserLocationAccess)

    const [locationListOption, setLocationListOption] = useState([])
    const [locationId, setLocationId] = useState(EmptyString)
    const [userLocationAccessList, setUserLocationAccessList] = useState([])

    const [isErrorLocation, setIsErrorLocation] = useState(false)

    // Filter Event

    const locationChange = (e) => { setLocationId(e.value) }

    // Modal

    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading({ isOpen: true })

        getLocationList().then(() => {
            getUserLocationAccessList().then(() => {
                setLoading({ isOpen: false })
            })
        })
        
        // fBindGrid(0)
    }, [])

    // Function Api Call

    const getLocationList = async() => {
        await apiGetLocationList({
            data: {
                userId: userId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                let tempArray = []

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].locationName.toUpperCase(), value: String(data[i].locationId) })
                }

                setLocationListOption(tempArray)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const insertUserLocation = async(locationId) => {
        await apiInsertUserLocationAccess({
            data: {
                userId: userId,
                locationId: locationId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({ isOpen: false }) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getUserLocationAccessList = async() => {
        await apiGetUserLocationByUserId({
            data: {
                userId: userId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setUserLocationAccessList(response.data)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const deleteUserLocation = async(id) => {
        await apiDeleteUserLocation({
            data: {
                userLocationId: id
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({ isOpen: false }) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    

    // Function Button
    // function fEditBtnClick(userId){
    //     navigate("/setting/user/form?userId=" + userId + "&formType=Edit")
    // }
    // function fDeleteBtnClick(userId, status){
    //     setConfirmationModal({
    //         isOpen: true,
    //         data: {
    //             onSuccess: async () => {
    //                 setConfirmationModal({ isOpen: false })
    //                 setLoading({isOpen: true})

    //                 fDeleteUser(userId, status).then(() => {
    //                     fBindGrid(pageIndex)
    //                 })
    //             }
    //         }
    //     })
    // }

    // Function Grid
    
    // Button Click

    const addLocationBtnClick = (locationId) => {
        // Logic to add location access for the user
        if (validate()){
            setLoading({ isOpen: true })

            insertUserLocation(locationId).then(() => {
                getUserLocationAccessList().then(() => {
                    setLocationListOption([])
                    setLocationId(EmptyString)
                    getLocationList().then(() => {
                        setLoading({ isOpen: false })
                    })
                })
            })
        }
    }
    const deleteLocationBtnClick = (id) => {
        setLoading({ isOpen: true })

        deleteUserLocation(id).then(() => {
            getUserLocationAccessList().then(() => {
                setLocationListOption([])
                setLocationId(EmptyString)
                getLocationList().then(() => {
                    setLoading({ isOpen: false })
                })
            })
        })
    }


    // Validation

    const validate = () => {
        if (locationId !== null && locationId !== EmptyString){
            setIsErrorLocation(false)
            return true
        } else {
            setIsErrorLocation(true)
            return false
        }
    }
    

    return(
        <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-40 rounded-lg">
            <div className='z-50 bg-white w-full h-full xl:h-auto xl:w-3/4 2xl:w-1/2 overflow-y-auto shadow-lg rounded-lg p-8'>
                <div>
                    <span className="font-semibold text-2xl">Location Access</span>
                </div>
                <hr />

                <div className="flex gap-2 mt-5">
                    <div className="w-36">
                        <span>User</span>
                    </div>
                    <div>
                        <span>:</span>
                    </div>
                    <div>
                        <span>{ name }</span>
                    </div>
                </div>

                <div className="flex gap-2 items-center mt-12">
                    <div className="w-36">
                        <span>Location</span>
                    </div>
                    <div className="w-72">
                        <Dropdown value={locationId} options={locationListOption} onChange={locationChange} placeholder={"Select Location"} />
                    </div>
                    <div>
                        <button
                            className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                            onClick={() => {addLocationBtnClick(locationId)}}
                        >
                            <span>Add Location</span>
                        </button>
                    </div>
                </div>

                
                {isErrorLocation && (
                    <div className="flex gap-2 items-center">
                        <div className="w-36">
                            <span></span>
                        </div>
                        <div className="w-72">
                            <span className="text-red-600">Location must be selected!</span>
                        </div>
                        <div>
                        
                        </div>
                    </div>
                )}
                            
                <div className="mt-5">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Location Name</th>
                                <th className="font-semibold sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {userLocationAccessList?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ i + 1 }</td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ data.locationName }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <button 
                                                className={`button flex gap-2`} 
                                                onClick={() => deleteLocationBtnClick(data.userLocationId)}
                                            >
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                
                <div className="flex justify-end">
                    <button
                        className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md mt-5"
                        onClick={onClose}
                    >
                        <span>Close</span>
                    </button>
                </div>
                
                {/* Modal */}
                {failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
                {loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
                {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
                {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
            </div>

            <div className="fixed top-0 bottom-0 left-0 right-0 bg-app-matte-black opacity-60 z-30" />
        </div>
        
    )
}